module.exports = __webpack_public_path__ + "img/28.c65f4de5.jpg";